<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h5>Latest Releases</h5>
        <div class="ibox-tools pull-right">
          <a class="collapse-link">
            <i class="fa fa-chevron-up"></i>
          </a>
        </div>
      </div>
      <div class="ibox-content">
        <table class="table table-hover" id="money-sites">
          <thead>
          <tr>
            <th>Site</th>
            <th>Network</th>
            <th>Group</th>
            <th>Deployed</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="pbn in pbns" :key="pbn.id">
            <td><router-link :to="'/pbn/' + pbn.punyDomain">{{ pbn.domain }}</router-link></td>
            <td>{{ pbn.client.name }}</td>
            <td>{{ pbn.group ? pbn.group.name : '/' }}</td>
            <td>{{ pbn.buildActions['site-moved'].endTime.date | moment('from') }}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { Query } from '../../../../../mixins/helperMixin'

export default {
  data () {
    return {
      pbns: []
    }
  },
  computed: {
    ...mapGetters({
      filters: 'getViewFilters'
    })
  },
  watch: {
    filters () {
      this.loadLatestPbns()
    }
  },
  mounted () {
    this.loadLatestPbns()
  },
  mixins: [Query],
  methods: {
    loadLatestPbns () {
      axios.get('/pbn/list?orderBy=buildActions.site-moved.endTime&orderDir=DESC&buildAction[site-moved]=completed&limit=10' + this.buildQuery(this.filters))
        .then(r => {
          this.pbns = r.data.data
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Dashboard/Overview/LatestPbns.vue